import { twMerge } from '@faceup/ui'
import { Typography } from '@faceup/ui-base'

type PageTitleProps = {
  children: React.ReactNode
  description?: React.ReactNode
  className?: string
}

export const PageTitle = ({ children, description, className }: PageTitleProps) => (
  <div className={twMerge('w-full text-center', className)}>
    <Typography.Title data-test='page-title' className='mb-5'>
      {children}
    </Typography.Title>
    {description && <span data-test='page-description'>{description}</span>}
  </div>
)
